import type { FaireProductEntity } from "../../entity_types/product";

export const p_p564k34s5k: FaireProductEntity = {
  token: "p_p564k34s5k",
  type: "product",
  name: "Solid Argan Oil Shampoo Bar (No Artificial Fragrances)",
  brandToken: "b_3yerfaqmmt",
  brandName: "Desesh",
  imageUrl:
    "https://cdn.faire.com/fastly/57c908811ce9dafa9a2b4ce8404460d35816c11999f2e892b0dfc992baa9d5fb.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2262c0547b0230383f44ab67a620090ccb40d6ccff254436af722295d54f7a8e.jpeg",
    "https://cdn.faire.com/fastly/9ce7a6c9dd7ec06eb20ea49b261a75e4a14feead97b4576611aa198fa128fd75.png",
    "https://cdn.faire.com/fastly/98356cbbff6b5b925c751679b84fefd4da7ac2e055256fb21c9727905f4b64a1.png",
    "https://cdn.faire.com/fastly/8fb6c6a19697b804ad56633ac25526773824403dcbac523aa58a467c410e0e88.png",
    "https://cdn.faire.com/fastly/20f2cc11bf57293ae031fec0dbbbba3b30d771aa8a9e63c2f260638b6383fb2e.png",
    "https://cdn.faire.com/fastly/e4084e6515fca4ccbf374164ba8fbad3062e9dc6db0580b3e35b1494d6a2e32f.jpeg",
    "https://cdn.faire.com/fastly/6c0a6e367b54ad1e99060f0203b62053ea3ca9acef43bb0bd20272c3361f58d1.jpeg",
    "https://cdn.faire.com/fastly/2444552e2f2d5f96999be93f92ead9557b37e988e9df6f8aac1434bdfd4a21af.jpeg",
  ],
  priceDollars: 9.69,
  description:
    "Enjoy a premium salon-quality shampoo experience without the plastic bottle or harsh ingredients. Crafted in small batches in the USA, this concentrated solid shampoo bar is designed to replace 1-2 12oz bottles and is full of hydrating oils and nutrients. Use along with the conditioner bar to make your hair feel healthier, lighter, and bring back your natural shine. Made for all hair types and lathers up easily so you can use less. What's different? Premium quality ingredients, plastic free, phthalate free, paraben free, palm oil free, SLS free, vegan and cruelty free, no artificial fragrances or dyes, low waste plastic free cardboard packaging, and made in small batches in the United States.",
  tags: [],
  msrpDollars: 19.39,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:29.839Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
